import slugify from 'slugify';

const API_SAFE_SLUGIFY_OPTIONS = {
	replacement: '-',
	lower: false,
	trim: false,
} as const;

export function toApiSafeValue(value?: string): string | undefined {
	if (value === undefined) return value;

	return slugify(value, API_SAFE_SLUGIFY_OPTIONS)
		.replaceAll(/[^\w-]+/g, '')
		.replaceAll(/^-+/g, '');
}
